import React from "react";

import classNames from "classnames";
import ExitSvg from "../../svg/ExitSvg";

export default function NewCbtModal({
  closeModal,
  Title,
  Body,
  modalStyling,
  BtnAttr,
  confirmAction,
  actionButtonText,
}) {
  const btnClasses = classNames({
    // 'w-20 sm:w-36' : true,
    hidden: BtnAttr.disableBtn,
  });
  console.log(BtnAttr.c);
  return (
    <>
      <>
        <div className="justify-center items-center flex w-full overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative my-6 w-full">
            <div className={modalStyling}>
              <div className="flex justify-start rounded-t">
                <button
                  className="ml-auto bg-transparent border-0 opacity-9 float-right font-semibold outline-none focus:outline-none"
                  onClick={closeModal}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L13 13M1 13L13 1L1 13Z"
                      stroke="#C6C6CA"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <div
                className="text-xl leading-6 font-bold flex flex-col items-center justify-center"
                style={{ fontSize: "24px" }}
              >
                <ExitSvg />
                <Title />
              </div>
              <div className="mx-auto">
                <Body />
              </div>
              <div className="modal-btns">
                <button
                  className="submit-action-btn"
                  onClick={() => confirmAction()}
                >
                  {actionButtonText}{" "}
                </button>
                <button className="cancel-action-btn" onClick={closeModal}>
                  Cancel
                </button>
              </div>

              {/* <div className="mt-6 w-36">
                <div className="flex justify-between space-x-4 > *">
                  <ButtonWhite
                    classsName="w-20 sm:w-36"
                    text={whiteBtnAttr.text}
                    onClick={whiteBtnAttr.onClick}
                  />
                  <Button
                    classes={btnClasses}
                    type="submit"
                    loading={BtnAttr.loading}
                    text={BtnAttr.text}
                    onClick={BtnAttr.onClick}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div
          className="opacity-25 fixed inset-0 z-40 bg-black"
          onClick={closeModal}
        ></div>
      </>
    </>
  );
}
